import { render, staticRenderFns } from "./hdyy_details.vue?vue&type=template&id=56677c08&scoped=true&"
import script from "./hdyy_details.vue?vue&type=script&lang=js&"
export * from "./hdyy_details.vue?vue&type=script&lang=js&"
import style0 from "./hdyy_details.vue?vue&type=style&index=0&id=56677c08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56677c08",
  null
  
)

export default component.exports